import { render, staticRenderFns } from "./multiChangeStatus.vue?vue&type=template&id=5badf740&scoped=true"
import script from "./multiChangeStatus.vue?vue&type=script&lang=js"
export * from "./multiChangeStatus.vue?vue&type=script&lang=js"
import style0 from "./multiChangeStatus.vue?vue&type=style&index=0&id=5badf740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5badf740",
  null
  
)

export default component.exports